import { render, staticRenderFns } from "./ResearchStatementModal.vue?vue&type=template&id=25da7b3f&"
import script from "./ResearchStatementModal.vue?vue&type=script&lang=js&"
export * from "./ResearchStatementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports